import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import Icon from '@amzn/awsui-components-console/icon';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import './EmptyState.scss';

export interface EmptyStateProps {
  title: string;
  description: string;
  icon?: 'search' | 'folder' | 'file' | 'status-info' | 'status-warning';
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon = 'search' }) => {
  return (
    <div className="empty-state">
      <Box textAlign="center" padding={{ vertical: 'xxxl' }}>
        <SpaceBetween size="m">
          <div className="empty-state__icon">
            <Icon name={icon} size="big" variant="subtle" />
          </div>
          <Box variant="h2" color="text-body-secondary">
            {title}
          </Box>
          <Box variant="p" color="text-body-secondary">
            {description}
          </Box>
        </SpaceBetween>
      </Box>
    </div>
  );
};

export default EmptyState;
